export const DECIMAL_PLACES = {
    DEFAULT: 2,
    AGGREGATED: 4,
} as const;

export const UNIT_LABELS = {
    CO2: 'tCO2eq',
    KWH: 'kWh',
    ML: 'ML',
    T: 'T',
} as const;
